import { useEffect, useRef, useState } from "react";
import { SKELETON_MIN_DURATION_MS } from "@/lib/constants/ui";

export const useDelayedFlag = (
  flag,
  minDuration = SKELETON_MIN_DURATION_MS,
) => {
  const [enabled, setEnabled] = useState(false);
  const timerRef = useRef(null);
  const startRef = useRef(null);

  useEffect(() => {
    const resolvedMin = Number.isFinite(minDuration)
      ? Math.max(minDuration, 0)
      : 0;

    if (flag) {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
      if (!enabled) {
        setEnabled(true);
      }
      if (startRef.current === null) {
        startRef.current = Date.now();
      }
      return;
    }

    if (!enabled) {
      startRef.current = null;
      return;
    }

    const elapsed = startRef.current
      ? Date.now() - startRef.current
      : resolvedMin;
    const remaining = Math.max(resolvedMin - elapsed, 0);

    if (remaining === 0) {
      setEnabled(false);
      startRef.current = null;
      return;
    }

    if (!timerRef.current) {
      timerRef.current = setTimeout(() => {
        timerRef.current = null;
        startRef.current = null;
        setEnabled(false);
      }, remaining);
    }

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [enabled, flag, minDuration]);

  return enabled;
};
